/** @format */

import config from "../../config";

// a quick sort algorithm to sort arrays by rating and return new array
export const sortBy = (arr, key) => {
	if (arr.length <= 1) return arr;
	const pivot = arr[arr.length - 1];
	const left = [];
	const right = [];
	for (let i = 0; i < arr.length - 1; i++) {
		if (arr[i][key] > pivot[key]) {
			left.push(arr[i]);
		} else {
			right.push(arr[i]);
		}
	}
	return [...sortBy(left, key), pivot, ...sortBy(right, key)];
};

//a function to sort the array by popularity
export const sortByPopularity = (array) => {
	let arr = array;
	return arr.sort((a, b) => {
		return b.popularity - a.popularity;
	});
};

//a function to sort  the array by id
export const sortByCreated = (array) => {
	let arr = array;
	return arr.sort((a, b) => {
		return b.id > a.id;
	});
};

//a function to sort the array by id
export const sortById = (array) => {
	let arr = array;
	return arr.sort((a, b) => {
		return b.id > a.id;
	});
};

//a function to shuffle array in random order
export const shuffleArray = (array) => {
	let arr = array;
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
};

//returning the array where array.status is 1
export const filterByStatus = (array) => {
	return array.filter((item) => {
		return item.status === 1;
	});
};

//to remove spaces form a string and add _ in between
export const removeSpaces = (string) => {
	try {
		return string.replace(/\s/g, "_");
	} catch (err) {
		console.log(err);
	}
};

//return a string with only first 100 characters
export const getFirst100Characters = (string) => {
	return string.substring(0, 100);
};

//function to return an array which contain the given studio name in studios array
export const filterByStudio = (array, studio) => {
	if (array === undefined) return [];

	return array.filter((item) => {
		return (
			item.studios.filter((studioName) => {
				return studioName.name === studio;
			}).length > 0
		);
	});
};

//filter movies
// a function to return items of array if item.seasons.episode.format === 4
//

export const filterMovies = (arr) => {
	//arr
	return arr.filter((item) => {
		//arr -> arr.seasons
		return (
			item.seasons.filter((seasons) => {
				//arr -> arr.seasons.episodes
				return (
					seasons.episodes.filter((ep) => {
						return ep.format === 1;
					}).length > 0
				);
			}).length > 0
		);
	});
};

//return an array of genre containing bg image url property extracted from arr2
export const getGenres = (genre, arr2) => {
	let newArray = [];
	for (let i = 0; i < arr2.length; i++) {
		let gen = genre[i];
		let bg = arr2[i].bg_image;
		newArray.push({ gen, bg });
	}
	return newArray;
};

//a function to cut a sting in half and return the first half
export const getFirstHalf = (string) => {
	return string ? string.substring(0, string.length / 2) : "";
};

export const updateImagePath = (
	array,
	cover_image_name = config.API_PARAMS.cover_image,
	bg_image_name = config.API_PARAMS.bg_image
) => {
	let ar = [];
	for (let i = 0; i < array.length; i++) {
		ar.push({
			...array[i],
			cover_image: array[i][cover_image_name],
			bg_image: array[i][bg_image_name],
		});
	}
	return ar;
};

export const randomColor = () => {
	const colors = [
		"#FF0000",
		"#FF7F00",
		"#FFFF00",
		"#00FF00",
		"#0000FF",
		"#1AA0A0",
		"#8F00FF",
		"#FF00FF",
		"#00FFFF",
		"#00FFA0",
		"#00FFFF",
		"#00AAff",
	];

	return colors[Math.floor(Math.random() * colors.length)];
};